import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Transition as _Transition } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Abrir empresas", -1)
const _hoisted_2 = {
  key: 0,
  class: "text-white"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col items-start"
}
const _hoisted_4 = { class: "text-sm font-semibold leading-6 line-clamp-1" }
const _hoisted_5 = { class: "text-xs leading-5" }
const _hoisted_6 = { class: "py-1" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex items-center" }

import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { ChevronDownIcon, CheckIcon } from "@heroicons/vue/20/solid";
import { useProfileStore } from "@/stores/useProfileStore";
import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'tenant-selector',
  setup(__props) {

const profileStore = useProfileStore();
const { loading, error, selectedTenant, userNavigation } =
  storeToRefs(profileStore);
const { changeTenant } = profileStore;

function formatCNPJ(cnpj: string | undefined): string {
  if (!cnpj) return "";
  return cnpj.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
    "$1.$2.$3/$4-$5"
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Menu), {
    as: "div",
    class: "relative"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(MenuButton), { class: "flex items-center justify-between p-2 border border-parrot-1 rounded-md w-full lg:w-52 text-white hover:bg-parrot-1 transition-colors duration-200" }, {
        default: _withCtx(() => [
          _hoisted_1,
          (_unref(loading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Loading..."))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(selectedTenant)?.name), 1),
                _createElementVNode("span", _hoisted_5, _toDisplayString(formatCNPJ(_unref(selectedTenant)?.tenant)), 1)
              ])),
          (_unref(userNavigation).length > 1)
            ? (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
                key: 2,
                class: "h-5 w-5 text-white",
                "aria-hidden": "true"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-100",
        "enter-from-class": "transform opacity-0 scale-95",
        "enter-to-class": "transform opacity-100 scale-100",
        "leave-active-class": "transition ease-in duration-75",
        "leave-from-class": "transform opacity-100 scale-100",
        "leave-to-class": "transform opacity-0 scale-95"
      }, {
        default: _withCtx(() => [
          (_unref(userNavigation).length > 1)
            ? (_openBlock(), _createBlock(_unref(MenuItems), {
                key: 0,
                class: "absolute w-full right-0 z-10 mt-2 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userNavigation), (item) => {
                      return (_openBlock(), _createBlock(_unref(MenuItem), {
                        key: item.tenant
                      }, {
                        default: _withCtx(({ active }) => [
                          _createElementVNode("a", {
                            href: "#",
                            class: _normalizeClass([
                active ? 'bg-gray-100 text-parrot' : 'text-gray-700',
                'block px-4 py-2 text-sm',
              ]),
                            onClick: ($event: any) => (_unref(changeTenant)(item))
                          }, [
                            _createElementVNode("div", _hoisted_8, [
                              (item.tenant === _unref(selectedTenant)?.tenant)
                                ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                                    key: 0,
                                    class: "mr-2 h-4 w-4 text-parrot",
                                    "aria-hidden": "true"
                                  }))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", {
                                class: _normalizeClass({ 'ml-6': item.tenant !== _unref(selectedTenant)?.tenant })
                              }, _toDisplayString(formatCNPJ(item.tenant)), 3)
                            ])
                          ], 10, _hoisted_7)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})